"use client";

import { useLingui } from "@lingui/react/macro";
import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";
import { i18nConfig } from "../../../i18n-config";

export const LanguageChanger = () => {
	const { i18n } = useLingui();
	const currentLocale = i18n.locale;
	const router = useRouter();
	const currentPathname = usePathname();
	return (
		<select
			onChange={(e) => {
				const newLocale = e.target.value;

				// set cookie for next-i18n-router
				const days = 30;
				const date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				const expires = date.toUTCString();
				document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/`;

				// redirect to the new locale path
				if (currentLocale === i18nConfig.defaultLocale) {
					router.push(`/${newLocale}${currentPathname}`);
				} else {
					router.push(currentPathname.replace(`/${currentLocale}`, `/${newLocale}`));
				}

				router.refresh();
			}}
			value={currentLocale}
		>
			<option value="en">English</option>
			<option value="fr">French (Canada)</option>
			<option value="es">Spanish (United States)</option>
		</select>
	);
};
